import { Navigate, Outlet } from 'react-router-dom';
import { isAdmin, isAuthenticated, isClient } from '../login/controller/login-controller';
import { ROUTES } from '../constants';
import { useLocation } from 'react-router-dom';
import { usePermissionViewModel } from '../pages/admin/permissions/viewmodel/permission-viewmodel';


/**
 * Protected route component that allows access only to authenticated users
 * with optional admin role check
 */
const ProtectedRoute = ({ adminOnly = false, redirectPath = ROUTES.login, adminRoutes }) => {
  const authenticated = isAuthenticated();
  const adminUser = isAdmin();
  const location = useLocation();
  const { hasPermission } = usePermissionViewModel();

  const element = location.state?.element || null;

  const menuName = element?.props?.menuName;

  // Redirect to login if not authenticated
  if (!authenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  // Block Client users from accessing admin/backoffice
  if (adminOnly && isClient()) {
    return <Navigate to={ROUTES.home} replace />;
  }

  // Redirect only when at /admin (i.e., the index route)
  const isAdminRoot = /^\/admin\/?$/.test(location.pathname);
  if (isAdminRoot && !adminUser) {

    // const firstRoute = adminRoutes.find(
    //   (route) => route.action === 'read' && (hasPermission('read',route.menuName))
    // );

    const hasReadOrWriteAccess = (route) => {
      const validActions = ['read', 'write'];

      const actions = Array.isArray(route.action) ? route.action : [route.action];

      return actions.some(
        (act) => validActions.includes(act) && hasPermission(act, route.menuName)
      );
    };

    const firstRoute = adminRoutes
      .filter(hasReadOrWriteAccess)
      .sort((a, b) => {
        const aHasRead = Array.isArray(a.action) ? a.action.includes('read') : a.action === 'read';
        const bHasRead = Array.isArray(b.action) ? b.action.includes('read') : b.action === 'read';
        return bHasRead - aHasRead; // sort: read (true=1) before write (false=0)
      })[0];


    if (firstRoute && firstRoute.path) {
      return <Navigate to={`/admin/${firstRoute.path}`} replace />;
    }
  }
  // If adminOnly flag is true, check if user is admin
  // if (adminOnly && !adminUser) {
  //   return <Navigate to={ROUTES.home} replace />;
  // }

  // Render child routes
  return <Outlet />;
};

export default ProtectedRoute;